import { ActionTypes } from '../constants/index';

export const fetchUpdateCommissionRules = (payload: any) => ({
  type: ActionTypes.COMMISSION_RULES_UPDATE_REQUEST,
  payload: {
    commissionId: payload.commissionId,
    percentage: payload.percentage
  },
});